<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body">
          <div class="fixed">
            <div class="header-item">{{ $t('泵房名称') }}</div>
            <div class="header-item">{{ $t('进水压力(MPa)') }}</div>
            <div class="header-item">{{ $t('最大出水压力(MPa)') }}</div>
            <div class="header-item">{{ $t('出水流量(m³/h)') }}</div>
            <div class="header-item">{{ $t('水质监控') }}</div>
            <div class="header-item">{{ $t('更新时间') }}</div>
          </div>
          <div style="overflow: hidden;height: 100%;">
            <vue-seamless-scroll :data="list" class="seamless-warp" ref="seamlessScroll" :class-option="classOption" @ScrollEnd="ScrollEnd">
              <ul class="list-ul">
                <li class="list-row" v-for="(item, index) in list" :key="index">
                  <div class="list-item">{{ item.name}}</div>
                  <div class="list-item">{{ item.jsyl}}</div>
                  <div class="list-item">{{ item.csyl }}</div>
                  <div class="list-item">{{ item.csll }}</div>
                  <div class="list-item">{{ item.szjk }}</div>
                  <div class="list-item">{{ item.updateTime }}</div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
    </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  components:{
    vueSeamlessScroll
  },
    data() {
        return{
            title: this.$t('泵房实时数据'),
            url:{},
            list:[
              {name:'泵房1',jsyl:3.45,csyl:2.08,csll:12.34,szjk:'98%',updateTime:'06-15 12:15'},
              {name:'泵房1',jsyl:3.45,csyl:2.08,csll:12.34,szjk:'98%',updateTime:'06-15 12:15'},
              {name:'泵房1',jsyl:3.45,csyl:2.08,csll:12.34,szjk:'98%',updateTime:'06-15 12:15'},
              {name:'泵房1',jsyl:3.45,csyl:2.08,csll:12.34,szjk:'98%',updateTime:'06-15 12:15'},
              {name:'泵房1',jsyl:3.45,csyl:2.08,csll:12.34,szjk:'98%',updateTime:'06-15 12:15'},
            ],
        }
    },
    computed: {
      goOn() {
        return this.errorNum < 5;
      },
      classOption() {
        return {
          step: 0.5, // 数值越大速度滚动越快
          limitMoveNum: this.list.length, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    mounted() {
    },
    methods: {
      ScrollEnd() {
        // if(this.goOn) {
        //   this.queryList()
        // }
      },
        init() {
          
        },
    },
}
</script>
<style lang="less" scoped>
  .fixed {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    background-color: #08306F;
    // margin: 10px 3px;
    // padding: 0 10px;
    color: #FFF;
    height: 30px;
  
    .header-item {
      width: 28.33%;
      text-align: center;
    }
  
    .header-order {
      width: 15%;
      text-align: center;
    }
  }
  
  .plant-bg {
    height: calc(100% - 40px);
    overflow: hidden;
    // background: url(../../../assets/img/plant5.png) center center no-repeat;
    // background-size: 100% 100%;
  }
  
  .list-ul {
    /* width: 100%;
      background: #f67;
      display: flex;
      justify-content: space-between; */
  }
  
  .list-row {
    // margin: 0 20px;
    color: #b6deff;
    display: flex;
    height: 33px;
    align-items: center;
    line-height: 35px;
    border: 1px solid #011a3a;
    // background: url(../../../assets/img/list-bg.png) center no-repeat;
    // background-size: 100% 100%;
  
    .order {
      // background: #0989ff;
      width: 48px;
      height: 18px;
      // border: 2px solid #0759a5;
      border-radius: 2px;
      text-align: center;
      line-height: 18px;
      color: #fff;
    }
  }
  
  .list-row .list-item {
    width: 28.33%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: #fff;
  }
  
  .list-order {
    width: 15%;
    display: flex;
    justify-content: center;
  }
  
  .fill-cicle {
    height: 10px;
    width: 10px;
    border-radius: 10px;
    box-shadow: 0 0 5px 5px rgba(255, 0, 0, 0.5);
  }
  
  ul {
    padding-inline-start: 0;
  }
  
  .seamless-warp {
    height: 100%;
  }
  
  .seamless-warp:hover {
    overflow-y: scroll;
  }
  
  .seamless-warp::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .seamless-warp::-webkit-scrollbar-track {
    background: #0e0c4f;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-thumb {
    background: #292f88;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-corner {
    background: #0e0c4f;
  }
</style>